
export const environment = {

  production: false,
  enableDebug: true,
  apiUrl:"https://dev-brokerhubapi.freepointsolutions.com/partner-portal/",
  baseUrl: 'https://fesportal.okta.com',
  clientId: '0oa18wxlmLMiUylDL696',
  issuer: 'https://fesportal.okta.com/oauth2/default',
  redirectUri: 'https://dev-brokerhub.freepointsolutions.com/login/callback',
  allowedOrigins: 'https://dev-brokerhubapi.freepointsolutions.com',
};
